import { CustomerInterface } from "interfaces";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "reducer/store";
import { bulkSetUserInfo } from "reducer/user.slice";
import { api, ui, utils } from "services";

export default function VerifyMailPage() {
  const { t } = useTranslation();
  const [isVerified, setIsVerifed] = useState(null);
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const { token } = useParams();
  useEffect(() => {
    api.verifyChangeMail(token).then(data => {
      setIsVerifed(true);
      ui.alertSuccess('Your email address has been successful changed !', "")
      if (user?.[CustomerInterface.id]) {
        dispatch(bulkSetUserInfo(data));
      }
    }).catch(err => {
      ui.alertFailed('Your email address has been failed changed !', "Please try again later !")
      setIsVerifed(false);
    })
  }, [])

  return (
    <div className="w-full dao-container">
    </div>
  )
}
